const STAT_DEFS = [
  { label: "Found", key: "FOUND" },
  { label: "Not found", key: "NOT_FOUND" },
  { label: "Invalid", key: "INVALID" },
  { label: "No range", key: "NO_RANGE" },
  { label: "Errors", key: "ERROR" },
];

export default function BulkStats({ counts }) {
  return (
    <div className="mt-10 grid grid-cols-2 sm:grid-cols-5 gap-4">
      {STAT_DEFS.map((s) => (
        <div
          key={s.key}
          data-testid={`bulk-stat-${s.key}`}
          className="bg-white border border-border/60 rounded-xl p-4"
        >
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#5B695E]">
            {s.label}
          </div>
          <div className="font-heading text-3xl mt-1">{counts[s.key] || 0}</div>
        </div>
      ))}
    </div>
  );
}
